import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber4Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNumber4Square"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12.7207 16.2275V14.4756H8.60156V13.5146C9.74414 11.5986 11.0391 9.53613 12.2227 7.77246H13.752V13.5322H14.9531V14.4756H13.752V16.2275H12.7207ZM9.67969 13.5381H12.7266V8.75098H12.6562C11.707 10.1689 10.5996 11.915 9.67969 13.4678V13.5381Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber4Square;
